"use client";

import { useCallback } from "react";
import type { Id } from "@convex/_generated/dataModel";
import { captureMessage } from "@/lib/error-tracking";

export function useMarketplaceFailureReporter(context: {
  productId: Id<"products">;
  fulfillment: "pickup" | "delivery";
  offerType: "pay" | "free" | "charge";
  quantity: number;
}) {
  const { productId, fulfillment, offerType, quantity } = context;
  return useCallback(
    (message: string) => {
      captureMessage("Public recycle marketplace flow failed", {
        level: "warning",
        tags: { flow: "public_recycle_listing", step: "submit_bid" },
        extra: { productId, fulfillment, offerType, quantity, message },
      });
    },
    [fulfillment, offerType, productId, quantity],
  );
}
